import React, { useState } from 'react';
import { Modal } from 'antd';
import { AddUserModalProps } from 'enums/AddUserModalProps';
import styles from '../Forms/CompanyDetailsForm/CompanyDetails.module.scss';
import InputField from '../InputField';
import COSelect from '../COSelect';
import COButton from '../COButton';
import { getCompanyDetailsFields } from '../Forms/CompanyDetailsForm/CompanyDetailsFormFields';
import { RcFile } from 'antd/lib/upload';
import { CompanyDetailFormPropsEnum } from 'enums/CompanyDetailsFormEnums';
import { Formik, Form as FormikForm } from 'formik';

import {
  initialValues,
  validationSchema,
} from '../Forms/CompanyDetailsForm/CompanyDetailsFormConstants';
import { Company } from 'models/Company/Company.model';
import { useUserContext } from 'context/UserContext';
import CustomImageUpload from './upload';
import { modalCloseIcon } from '../OrganizationModal';
import UserCompanyService from 'services/AuthenticationService/userCompany.service';
interface EditLogoModal {
  showModalState: boolean;
  handleModalCancel: (payload: boolean) => void;
  setUpdateLogoModal: React.Dispatch<React.SetStateAction<boolean>>;
  data: Company | undefined;
}

const EditLogoModal: React.FC<EditLogoModal> = ({
  showModalState,
  handleModalCancel,
  setUpdateLogoModal,
  data,
}: EditLogoModal) => {
  const { companyImageUrl } = useUserContext();
  const handleCancelModal = () => {
    setImage(undefined);
    handleModalCancel(false);
  };
  const { buttonLoading, uploadCompanyImage } = UserCompanyService();
  const Fields = getCompanyDetailsFields({
    revenueRange: [],
    companyMeta: [],
    referenceData: [],
  });

  const [image, setImage] = useState<RcFile>();

  const handleApiSubmission = async () => {
    if (image) {
      await uploadCompanyImage(image);
      setUpdateLogoModal(false);
    } else {
      console.error('No image selected');
    }
  };

  const dataValues = {
    ...initialValues,
    companyName: data?.name,
    companyType: data?.type,
    revenuerange: data?.revenueRange,
    associationMember: data?.member,
    source: data?.referral,
    image: companyImageUrl || data?.image,
  };
  return (
    <>
      <Modal
        destroyOnClose={true}
        width={AddUserModalProps.MODAL_WIDTH}
        footer={null}
        wrapClassName={styles.modalContainer}
        open={showModalState}
        closeIcon={modalCloseIcon}
        onCancel={handleCancelModal}>
        <div className={styles.uploadFormContainer}>
          <h2>{AddUserModalProps.UPDATE_LOGO}</h2>
          <div className={styles.fieldsContainer}>
            <Formik
              initialValues={dataValues}
              validationSchema={validationSchema}
              onSubmit={values => handleApiSubmission()}>
              {() => (
                <FormikForm>
                  <div className={styles.uploadContainer}>
                    <div className={styles.uploadContainer}>
                      <CustomImageUpload image={image} setImage={setImage} />
                    </div>
                  </div>
                  {Fields.map((field, index) => {
                    return (
                      <div key={index} className={styles.fieldContainer}>
                        {field.select ? (
                          <COSelect
                            disabled
                            placeholderstring={field.placeholder}
                            name={field.name}
                            options={field.selectOptions}
                            label={field.label}
                          />
                        ) : (
                          <InputField
                            disabled
                            name={field.name}
                            placeholderstring={field.placeholder}
                            label={field.label}
                          />
                        )}
                      </div>
                    );
                  })}
                  <div className={styles.buttonContainer}>
                    <COButton loading={buttonLoading} submit disabled={!image}>
                      {CompanyDetailFormPropsEnum.UPDATE}
                    </COButton>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EditLogoModal;
